module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAABFElEQVQ4T7WTsUoDURBFz32CTTDYpVFQlBT2gp8Qs3Yi2tikC5aWYmknCH6BFjaiIOKivY0g+AXRFGKjYBUhkuWN8MjKoiEkq5nu8eYe7p1hFDetgucIKJGjzGjhqCtu2DNiKgcjK3lT/Gj2R0iQjxzkAdd1mjpW9539+w7Ty9G5PPvecSEoGWxhjEkcAi/es4bYdWI5O5LfIM/6/Qlni5ucAqvjMOkLJMkHLcRNdZbouklkxmV/kNFGPABLIZ7xhEiAchAad4gFoNgflHOFI9/a0L7+y9HrT5A3wmAHLkEHUcuCDM9Gu8PtwBSgMMFnZVrvKchw1KozHEvKdXspaDua4wDyQcLRXjVsZ2Vee8PE6dX7BeizeuyHPKXmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/num.png
// module id = tGMc
// module chunks = 0